import { cn } from '@/utils/tailwind';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { type MarketStoreListItem } from '../../_consts/constants';

interface TabIndicatorProps {
  marketList: MarketStoreListItem[];
  tabRefs: React.MutableRefObject<Record<string, HTMLButtonElement | null>>;
  tabBarRef: React.MutableRefObject<HTMLDivElement | null>;
}

const ReviewTabIndicator = ({ marketList, tabRefs, tabBarRef }: TabIndicatorProps) => {
  // 인디케이터 위치/크기 상태
  const [indicator, setIndicator] = useState<{
    left: number;
    top: number;
    width: number;
    height: number;
  } | null>(null);

  const [searchParams] = useSearchParams();
  const selectedMarket = searchParams.get('select');

  useEffect(() => {
    // ✅ 선택된 마켓이 없으면 '전체' 버튼 기준
    const key = selectedMarket ?? '전체_0';
    const target = tabRefs.current[key];

    if (target && tabBarRef.current) {
      const containerRect = tabBarRef.current.getBoundingClientRect();
      const nodeRect = target.getBoundingClientRect();

      setIndicator({
        left: nodeRect.left - containerRect.left + tabBarRef.current.scrollLeft,
        top: nodeRect.top - containerRect.top,
        width: nodeRect.width,
        height: nodeRect.height,
      });
    } else {
      setIndicator(null);
    }
  }, [selectedMarket, marketList]);

  if (!indicator) return null;

  return (
    <motion.span
      layout
      transition={{
        type: 'spring',
        stiffness: 400,
        damping: 30,
      }}
      className={cn('absolute z-0 rounded-[8px] bg-white shadow-sm')}
      style={{
        left: indicator.left,
        top: indicator.top,
        width: indicator.width,
        height: indicator.height,
      }}
    />
  );
};

export default ReviewTabIndicator;
